<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'SideMenu',
})
</script>
<template>
  <a-layout-sider id="print-hide-sider" :class="['sider', isDesktop ? null : 'shadow', theme, fixSiderbar ? 'ant-fixed-sidemenu' : null]"
    width="256px" :collapsible="collapsible" v-model:collapsed="sideMenuCollapsed" :trigger="null">
    <logo :collapsed="collapsed"/>
    <!-- 核心修改：传给Menu的是过滤后的menus -->
    <Menu :collapsed="collapsed" :menu="filterHiddenMenus(props.menus)" :theme="theme" :mode="mode" @select="onSelect"></Menu>
  </a-layout-sider>
</template>



<script lang="ts" setup name="SideMenu">
import { watch, ref } from 'vue'
import Logo from '@/components/tools/Logo.vue'
import Menu from './Menu.vue'
import { isDesktop } from '@/utils/device'
import useSiteSettings from '@/store/useSiteSettings'

const props = defineProps({
  mode: {
    type: String,
    required: false,
    default: 'inline'
  },
  theme: {
    type: String,
    required: false,
    default: 'dark'
  },
  collapsible: {
    type: Boolean,
    required: false,
    default: false
  },
  collapsed: {
    type: Boolean,
    required: false,
    default: false
  },
  menus: {
    type: Array,
    required: true
  }
})

const sideMenuCollapsed = ref(false)
watch(
  () => props.collapsed,
  (newVal) => {
    sideMenuCollapsed.value = newVal
  },
  {
    immediate: true
  }
);

const emit = defineEmits(['menuSelect'])

// 核心修复：先深拷贝原数组，再过滤（避免修改响应式原数据）
const filterHiddenMenus = (menuList) => {
  // 深拷贝：打破响应式关联，避免修改原数组触发递归更新
  const copyMenu = JSON.parse(JSON.stringify(menuList));
  
  // 递归过滤（操作拷贝后的数组，不影响原数据）
  const filter = (list) => {
    return list.filter(menuItem => {
      const isHidden = !!menuItem.meta?.hidden || !!menuItem.meta?.hideInMenu || !!menuItem.meta?.hideMenu;
      if (isHidden) return false;

      if (menuItem.children && menuItem.children.length > 0) {
        menuItem.children = filter(menuItem.children);
      }
      return true;
    });
  };

  return filter(copyMenu);
}

// const isMenuHidden = (menuItem) => {
//   // 识别 hidden/hideInMenu/hideMenu 等属性，任意一个为true则隐藏
//   return !!menuItem.meta?.hidden || !!menuItem.meta?.hideInMenu || !!menuItem.meta?.hideMenu
// }
const onSelect = (obj) => {
  emit('menuSelect', obj)
}
const { fixSiderbar } = useSiteSettings()
</script>

<style >

@media print {
  #print-hide-sider {
    display: none !important;
    visibility: hidden !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
    position: absolute !important;
    z-index: -9999 !important;
  }
  #print-hide-sider > * {
    display: none !important;
  }
}
</style>